import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags, faFileAlt, faTrash, faCheckCircle, faCopy, faPaste } from '@fortawesome/free-solid-svg-icons';
import { ActionsContext } from 'context/MenuBarActionsContext';
import '../css/advancedProducts.css';

export const BulkActionToolbar = ({ 
    selectedCount = 0,
    onClearSelection,
    gridRef
}) => {
    const { handleAction } = useContext(ActionsContext);

    if (selectedCount === 0) return null;

    const handleBulkAction = (actionType) => {
        if (handleAction) {
            handleAction(actionType);
        }
    };

    return (
        <div className="bulk-action-toolbar">
            <div className="selection-info">
                <strong>{selectedCount}</strong> {selectedCount === 1 ? 'product' : 'products'} selected
                <button
                    onClick={onClearSelection}
                    style={{
                        marginLeft: '12px',
                        background: 'none',
                        border: 'none',
                        color: '#2c7be5',
                        cursor: 'pointer',
                        fontSize: '12px',
                        textDecoration: 'underline'
                    }}
                >
                    Clear selection
                </button>
            </div>
            
            <div className="action-buttons">
                <button 
                    className="action-btn"
                    onClick={() => handleBulkAction('TAGS')}
                    title="Add or remove tags"
                >
                    <FontAwesomeIcon icon={faTags} />
                    <span>Tags</span>
                </button>
                
                <button 
                    className="action-btn"
                    onClick={() => handleBulkAction('ASSIGN__PRICING_TEMPLATE')}
                    title="Assign pricing template"
                >
                    <FontAwesomeIcon icon={faFileAlt} />
                    <span>Pricing Template</span>
                </button>
                
                <button 
                    className="action-btn"
                    onClick={() => handleBulkAction('ASSIGN_SHIPPING_TEMPLATE')}
                    title="Assign shipping template"
                >
                    <FontAwesomeIcon icon={faFileAlt} />
                    <span>Shipping Template</span>
                </button>
                
                <button 
                    className="action-btn"
                    onClick={() => handleBulkAction('REPRICE')}
                    title="Recalculate pricing"
                >
                    <FontAwesomeIcon icon={faCheckCircle} />
                    <span>Reprice</span>
                </button>
                
                <button 
                    className="action-btn"
                    onClick={() => handleBulkAction('COPY')}
                    title="Copy to clipboard"
                >
                    <FontAwesomeIcon icon={faCopy} />
                    <span>Copy</span>
                </button>
            </div>
        </div>
    );
};

export default BulkActionToolbar;
